import styled from 'styled-components';
import { fontStyle } from '@whitelabel/helpers/style';
import GeoSuggest from '../components/GeoSuggest';

export const StyledGeoSuggest = styled(GeoSuggest)`
  ${fontStyle('paragraph')};
  position: relative;
  text-align: start;
`;
